<div class="py-3" fxLayout="row" fxLayoutAlign="start center">
  <vex-skeleton class="w-14 mr-2" heigthTailwind="h-12" [circle]="true"></vex-skeleton>
  <vex-skeleton class="w-full" heigthTailwind="h-12"></vex-skeleton>
</div>
